// extracted by mini-css-extract-plugin
module.exports = {"container":"thread-item_container__2H1Z-","postContainer":"thread-item_postContainer__1SlVu","commentContainer":"thread-item_commentContainer__3P8rh"};